import React, { useEffect, useState, useCallback, useMemo } from "react";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { useHistory } from "react-router";
import { GetShoppingCart } from "../../Api/BarestServices";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import CompleteShopping from "../../Component/CompleteShopping/CompleteShopping";
import MenuBottom from "../../Component/menuBottom/MenuBottom";
import ShoppingBasket from "../../Component/ShoppingBasket/ShoppingBasket";
import Style from "./Shopping.module.css";
import { errorToast } from "../../Toast/Toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingBag, faStore, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const Shopping = () => {
  const history = useHistory();
  const [update, setUpdate] = useState(false);
  const [cartList, setCartList] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const getCartList = useCallback(() => {
    GetShoppingCart((succ, res) => {
      setLoading(false);
      if (succ) {
        if (res.status === "0") {
          errorToast("مشکلی در دریافت سبد خرید پیش آمده است");
        } else {
          setCartList(res.cart || []);
        }
      } else {
        console.error(res);
        setCartList([]);
      }
    });
  }, []);

  useEffect(() => {
    getCartList();
  }, [getCartList]);

  const setFinalize = () => {
    setUpdate(true);
    setTimeout(() => history.push("/finalizepurchase"), 600);
  };

  const cancelFinalize = () => {
    setUpdate(false);
  };

  const renderContent = () => {
    if (loading || cartList === undefined) {
      return (
        <div className={Style.loadingStyle}>
          <PointSpreadLoading color={"#c20c64"} size={"small"} />
          <p className={Style.loadingText}>در حال دریافت سبد خرید...</p>
        </div>
      );
    }

    if (cartList.length === 0) {
      return (
        <div className={Style.emptyContainer}>
          <div className={Style.emptyIconHolder}>
            <img
              src="/Assets/Images/Order/not2.png"
              alt="سبد خرید خالی"
              className={Style.emptyImage}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
            <div className={Style.bagFallback}>
              <FontAwesomeIcon icon={faShoppingBag} />
            </div>
          </div>
          <h2 className={Style.emptyTitle}>سبد خرید شما خالی است</h2>
          <p className={Style.emptySubtitle}>
            هیچ کالایی در سبد خرید شما وجود ندارد. می‌توانید از بین فروشگاه‌ها کالاهای مورد نیاز خود را انتخاب کنید.
          </p>
          <button
            type="button"
            className={Style.exploreBtn}
            onClick={() => history.push("/")}
          >
            <FontAwesomeIcon icon={faStore} />
            <span>مشاهده فروشگاه‌ها</span>
            <FontAwesomeIcon icon={faArrowLeft} className={Style.arrowIcon} />
          </button>
        </div>
      );
    }

    return (
      <div className={Style.BasketHolder}>
        {cartList.map((item, index) => (
          <ShoppingBasket
            key={item.supplier_id || index}
            supID={item.supplier_id}
            data={item}
            sendDescription={update}
            rerenderForce={getCartList}
            finalize={cancelFinalize}
          />
        ))}
      </div>
    );
  };

  const grandTotalPrice = React.useMemo(() => {
    if (!Array.isArray(cartList)) return 0;
    return cartList.reduce((cartSum, cart) => {
      const cartTotal = (cart.products || []).reduce((prodSum, item) => {
        const price = parseInt(item.off_price > 0 ? item.off_price : item.price || 0, 10);
        const count = parseInt(item.count || 1, 10);
        return prodSum + price * count;
      }, 0);
      return cartSum + cartTotal;
    }, 0);
  }, [cartList]);

  const grandTotalCount = React.useMemo(() => {
    if (!Array.isArray(cartList)) return 0;
    return cartList.reduce((cartSum, cart) => {
      const count = (cart.products || []).reduce((prodSum, item) => prodSum + parseInt(item.count || 1, 10), 0);
      return cartSum + count;
    }, 0);
  }, [cartList]);

  return (
    <div className={Style.ShoppingHolder}>
      <BurgerMenuTitle title={"سبد خرید"} />
      {renderContent()}
      {cartList && cartList.length > 0 && (
        <CompleteShopping
          finalize={setFinalize}
          totalPrice={grandTotalPrice}
          totalCount={grandTotalCount}
        />
      )}
      <MenuBottom />
    </div>
  );
};

export default Shopping;